import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Modal from "../../components/Modal";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  Row,
} from "reactstrap";

import {
  FaShieldAlt,
  FaUsers,
  FaCalendarCheck,
  FaAward,
} from "react-icons/fa";
import Carousel from "../../components/Carousel/swiper";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import InfoSection from "../../components/InfoSection/InfoSection";
import Marketing from "../../components/Marketing/index";
import Brands from "../../components/Brands/BrandsCard";
import Testimonials from "../../components/Testimonials/TestimonialCards";
import { send } from "emailjs-com";

import "../../App.css";
import ServicesScreen from "../../components/Services";

const Home = () => {
  const [toname] = useState("Arcus Builders");
  const [modal, setmodal] = useState(false);
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [phone, setphone] = useState("");
  const [requirments, setrequirments] = useState("");
  const [toSend, setToSend] = useState({});
  const data = {
    primary: true,
    lightBg: true,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: "From Concept to Creation",
    headline: '"A THRIFTY STYLE OF HOME LIVES"',
    description:
      "We have a team of highly experienced, world-class engineers. Our team provides exceptional customer service to our valued customers and continuously works together to develop innovative ideas for our projects. We deliver a well-structured experience in world-class architecture, where innovation meets structure. A vision is turned into reality through thoughtful design.",
    buttonLabel: "Get Started",
    imgStart: "",
    img: require("../../images/8539.jpg").default,
    alt: "Credit Card",
    start: "",
  };

  const handleSubmit = (e) => {
    "https://web.whatsapp.com://send?text=This is whatsapp sharing example using button&phone=+919947574356";
    // this.setState({ name: this.state.modalInputName });
    // setname("");
    // setemail('');
    // setphone('');
    // setrequirments('');
    // setmodal(false);
    // modalClose();

    console.log(name, toname, requirments, email, phone, "0000000000000");

    setToSend({
      from_name: name,
      to_name: toname,
      message: requirments,
      reply_to: email,
      contact: phone,
    });
    e.preventDefault();
    send(
      "service_lbhd8jn",
      "template_7gjgmwk",
      {
        from_name: name,
        to_name: toname,
        message: requirments,
        reply_to: email,
        contact: phone,
      },
      "user_yrrwA36meWcYoIhkrhSC2"
    )
      .then((response) => {
        console.log("SUCCESS!", toSend, response.status, response.text);
        setname("");
        setemail("");
        setphone("");
        setrequirments("");
        setmodal(false);
        modalClose();
      })
      .catch((err) => {
        console.log("FAILED...", err);
      });
  };

  const modalOpen = () => {
    // this.setState({ modal: true });
    setmodal(true);
  };

  const modalClose = () => {
    // this.setState({
    //   modalInputName: "",
    //   modal: false
    // });
    setmodal(false);
  };

  return (
    <div className="home-page">
      <Header />

      {/* <Navbar /> */}

      <div id="home" className="containers section-anchor">
        <InfoSection {...data} />
        <div className="hero-highlights">
          {[
            { icon: FaShieldAlt,      title: "Quality Construction", text: "Built with fine materials and trusted standards." },
            { icon: FaUsers,          title: "Expert Team",           text: "Skilled professionals delivering practical solutions." },
            { icon: FaCalendarCheck,  title: "On-Time Delivery",      text: "Committed to planned milestones and schedules." },
            { icon: FaAward,          title: "Customer Satisfaction", text: "Long-term relationships shaped by transparency." },
          ].map(({ icon: Icon, title, text }) => (
            <div className="hero-highlight" key={title}>
              <span className="hero-highlight__icon"><Icon /></span>
              <div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <section id="work" className="section-anchor">
        <Carousel />
      </section>

      <section id="services" className="section-anchor">
        <ServicesScreen />
      </section>

      <section id="testimonials" className="section-anchor">
        <Testimonials />
      </section>

     

      

      

      <section id="brands" className="section-anchor">
        <Brands />
      </section>

      <section id="vision" className="section-anchor">
        <Marketing />
      </section>

    

      {/* <Vision /> */}

      <section id="contact" className="section-anchor">
        <Footer />
      </section>

      {/* <div class="qkout" onClick={(e) => modalOpen(e)} style={{ top: "40%" }}>
        <div class="qkenq" id="pickup"></div>
      </div> */}
      <Modal show={modal} handleClose={(e) => modalClose(e)}>
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="9" lg="7" xl="6">
                <Card className="mx-4">
                  <CardBody className="p-4">
                    <Form>
                      <span onClick={() => modalClose()} class="bClose">
                        X
                      </span>
                      <div class="thnjmk">
                        <p className="thnjmk">
                          Email us with any questions or inquiries or use our
                          contact data.
                        </p>
                      </div>
                      <InputGroup className="mb-3">
                        <Input
                          type="text"
                          onChange={(e) => setname(e.target.value)}
                          placeholder="Your Name"
                        />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input
                          type="email"
                          onChange={(e) => setemail(e.target.value)}
                          placeholder="Email"
                        />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input
                          type="number"
                          onChange={(e) => setphone(e.target.value)}
                          placeholder="Phone Number"
                        />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <Input
                          type="textarea"
                          onChange={(e) => setrequirments(e.target.value)}
                          placeholder="Requirements"
                        />
                      </InputGroup>
                      <Button
                        style={{ backgroundColor: "#030318" }}
                        onClick={handleSubmit}
                        block
                      >
                        SEND
                      </Button>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </div>
  );
};

export default Home;
